module.exports = __webpack_public_path__ + "static/media/time_spend_emp_status.7a8077a1.png";